module.exports = __webpack_public_path__ + "ab1ce552.svg";